import type { ExpenseBadgeType } from './ExpenseBadge';

export interface BadgeConfig {
  type: ExpenseBadgeType;
  titleKey: string;
  amount: string;
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  delay: number;
}

// Badge order and content per language
// Order and positions match the original webp image animation
export const BADGE_CONFIGS: Record<string, BadgeConfig[]> = {
  en: [
    {
      type: 'lunch',
      titleKey: 'expense_badge.lunch',
      amount: '€28,00',
      position: 'bottom-left',
      delay: 0.1,
    },
    {
      type: 'laptop',
      titleKey: 'expense_badge.laptop',
      amount: '€1.000,00',
      position: 'top-right',
      delay: 0.25,
    },
    {
      type: 'subscriptions',
      titleKey: 'expense_badge.subscriptions',
      amount: '€80,00',
      position: 'bottom-right',
      delay: 0.5,
    },
    {
      type: 'furniture',
      titleKey: 'expense_badge.furniture',
      amount: '€240,00',
      position: 'top-left',
      delay: 0.37,
    },
  ],
  de: [
    {
      type: 'subscriptions',
      titleKey: 'expense_badge.subscriptions',
      amount: '€80,00',
      position: 'bottom-left',
      delay: 0.1,
    },
    {
      type: 'furniture',
      titleKey: 'expense_badge.furniture',
      amount: '€240,00',
      position: 'top-left',
      delay: 0.37,
    },
    {
      type: 'laptop',
      titleKey: 'expense_badge.laptop',
      amount: '€1.000,00',
      position: 'top-right',
      delay: 0.5,
    },
    {
      type: 'lunch',
      titleKey: 'expense_badge.lunch',
      amount: '€28,00',
      position: 'bottom-right',
      delay: 0.25,
    },
  ],
  fr: [
    {
      type: 'lunch',
      titleKey: 'expense_badge.lunch',
      amount: '€28,00',
      position: 'bottom-left',
      delay: 0.1,
    },
    {
      type: 'laptop',
      titleKey: 'expense_badge.laptop',
      amount: '€1.000,00',
      position: 'top-right',
      delay: 0.25,
    },
    {
      type: 'subscriptions',
      titleKey: 'expense_badge.subscriptions',
      amount: '€80,00',
      position: 'bottom-right',
      delay: 0.5,
    },
    {
      type: 'furniture',
      titleKey: 'expense_badge.furniture',
      amount: '€240,00',
      position: 'top-left',
      delay: 0.37,
    },
  ],
  nl: [
    {
      type: 'subscriptions',
      titleKey: 'expense_badge.subscriptions',
      amount: '€80,00',
      position: 'bottom-left',
      delay: 0.1,
    },
    {
      type: 'furniture',
      titleKey: 'expense_badge.furniture',
      amount: '€240,00',
      position: 'top-left',
      delay: 0.37,
    },
    {
      type: 'lunch',
      titleKey: 'expense_badge.lunch',
      amount: '€28,00',
      position: 'bottom-right',
      delay: 0.25,
    },
    {
      type: 'laptop',
      titleKey: 'expense_badge.laptop',
      amount: '€1.000,00',
      position: 'top-right',
      delay: 0.5,
    },
  ],
};

// Position styles for badges around the card
export const POSITION_STYLES: Record<BadgeConfig['position'], string> = {
  'top-left': 'absolute -top-7 -left-12',
  'top-right': 'absolute -top-8 -right-12',
  'bottom-left': 'absolute -bottom-7 -left-12',
  'bottom-right': 'absolute -bottom-6 -right-12',
};
